import React from 'react'
import { ThemeProvider } from '@leshen/ui'
import GlobalStyles from './CustomStyles'

const Wrapper = ({ children, customTheme }) => {
  return (
    <ThemeProvider theme={customTheme}>
      <GlobalStyles theme={customTheme} />
      {children}
    </ThemeProvider>
  )
}

export default Wrapper
